<div class="card">
  <div class="card-body" [ngClass]="cfg.primaryColor">

    sss
    <!-- <div class="row row-table">
      <div class="col-4 text-center p-4" [ngClass]="cfg.secondaryColor">
        <em class="fa-3x fa-fw" [ngClass]="cfg.icon"></em>
      </div>
      <div class="col-8 text-center p-2">
        <div class="h2 mt-0" *ngIf="cfg.dataType === 'number'">{{value | number}}</div>
        <div class="h2 mt-0" *ngIf="cfg.dataType === 'numberBold'">{{value | number}}</div>
        <div class="h2 mt-0" *ngIf="cfg.dataType === 'text'">{{value}}</div>
        <div class="text-uppercase">{{cfg.text}}</div>
      </div>
    </div> -->
  </div>
</div>
